export default __webpack_public_path__ + "static/media/hkd-flag.939f9805.svg";